module.exports = __webpack_public_path__ + "img/vazio_2_azul.ca87a138.svg";